var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center datacard"},[_c('p',{staticClass:"data"},[_vm._v(_vm._s(_vm.data))]),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.show_data))])])}
var staticRenderFns = []

export { render, staticRenderFns }